import type { RouteRecordRaw } from 'vue-router'

import { requireLoggedIn } from '~/router/guards'

export default [
  {
    path: 'settings',
    name: 'settings',
    component: () => import('~/components/auth/Settings.vue'),
    beforeEnter: requireLoggedIn()
  },
  {
    path: 'settings/applications/new',
    name: 'settings.applications.new',
    props: route => ({
      scopes: route.query.scopes,
      name: route.query.name,
      redirect_uris: route.query.redirect_uris
    }),
    component: () => import('~/components/auth/ApplicationNew.vue'),
    beforeEnter: requireLoggedIn()
  },
  {
    path: 'settings/plugins',
    name: 'settings.plugins',
    component: () => import('~/views/auth/Plugins.vue'),
    beforeEnter: requireLoggedIn()
  },
  {
    path: 'settings/applications/:id/edit',
    name: 'settings.applications.edit',
    component: () => import('~/components/auth/ApplicationEdit.vue'),
    props: true,
    beforeEnter: requireLoggedIn()
  }
] as RouteRecordRaw[]
